module.exports = __webpack_public_path__ + "img/prod-kitchen.eb3d0816.jpg";